import * as React from "react";
import * as PropTypes from "prop-types";

export interface FlagsProps {
    country: string;
    width: string;
    height: string;
}

export class Flags extends React.Component<FlagsProps, {}> {
    static propTypes = {
        country: PropTypes.oneOf(["es", "mx", "ie", "kh", "ph", "pt", "no", "usa", "us"])
            .isRequired,
        width: PropTypes.string.isRequired,
        height: PropTypes.string.isRequired
    };

    render() {
        const style = {
            width: this.props.width,
            height: this.props.height
        };

        return (
            <div style={style} className="flag-icon">
                <img style={style} src={`/images/${this.props.country}.svg`} />
            </div>
        );
    }
}
